import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import { hotelInfo } from '../mockData';

export const Footer = () => {
  return (
    <footer
      className="border-t"
      aria-label="Site footer"
      style={{
        backgroundColor: 'var(--bg-secondary)',
        borderColor: 'var(--border-light)'
      }}
    >
      <div className="container mx-auto px-6 md:px-10 pt-24 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 pt-6">
          {/* Brand */}
          <div>
            <h3
              className="text-2xl mb-4"
              style={{
                fontFamily: "'Crimson Text', serif",
                color: 'var(--text-primary)'
              }}
            >
              {hotelInfo.name}
            </h3>
            <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
              A sanctuary of refined comfort and tranquil living in the heart of Zimbabwe.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="text-sm font-medium mb-4 uppercase tracking-wider"
              style={{ color: 'var(--text-primary)' }}
            >
              Quick Links
            </h4>
            <div className="flex flex-col gap-3">
              <Link
                to="/rooms"
                className="body-small hover:underline"
                style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}
              >
                Rooms & Suites
              </Link>
              <Link
                to="/facilities"
                className="body-small hover:underline"
                style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}
              >
                Facilities
              </Link>
              <Link
                to="/gallery"
                className="body-small hover:underline"
                style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}
              >
                Gallery
              </Link>
              <Link
                to="/reviews"
                className="body-small hover:underline"
                style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}
              >
                Reviews
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="text-sm font-medium mb-4 uppercase tracking-wider"
              style={{ color: 'var(--text-primary)' }}
            >
              Contact Us
            </h4>
            <div className="flex flex-col gap-3">
              <a
                href={`tel:${hotelInfo.contact.phone}`}
                className="body-small flex items-center gap-2"
                style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}
              >
                <Phone size={16} />
                {hotelInfo.contact.phone}
              </a>
              <a
                href={`tel:${hotelInfo.contact.phone2}`}
                className="body-small flex items-center gap-2"
                style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}
              >
                <Phone size={16} />
                {hotelInfo.contact.phone2}
              </a>
              <a
                href={`mailto:${hotelInfo.contact.email}`}
                className="body-small flex items-center gap-2"
                style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}
              >
                <Mail size={16} />
                {hotelInfo.contact.email}
              </a>
              <a
                href={`mailto:${hotelInfo.contact.email2}`}
                className="body-small flex items-center gap-2"
                style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}
              >
                <Mail size={16} />
                {hotelInfo.contact.email2}
              </a>
              <p className="body-small flex items-start gap-2" style={{ color: 'var(--text-secondary)' }}>
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                {hotelInfo.location.address}
              </p>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4
              className="text-sm font-medium mb-4 uppercase tracking-wider"
              style={{ color: 'var(--text-primary)' }}
            >
              Follow Us
            </h4>
            <div className="flex gap-4">
              <a
                href={hotelInfo.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="p-2 border hover:bg-[var(--olive-light)] hover:border-[var(--olive-primary)] transition-all"
                style={{ borderColor: 'var(--border-light)', color: 'var(--text-primary)' }}
              >
                <Facebook size={20} />
              </a>
              <a
                href={hotelInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="p-2 border hover:bg-[var(--olive-light)] hover:border-[var(--olive-primary)] transition-all"
                style={{ borderColor: 'var(--border-light)', color: 'var(--text-primary)' }}
              >
                <Instagram size={20} />
              </a>
            </div>
            <a
              href={hotelInfo.social.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-4 btn-secondary"
            >
              WhatsApp Us
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          className="mt-12 pt-8 border-t flex flex-col md:flex-row justify-between items-center gap-4"
          style={{ borderColor: 'var(--border-light)' }}
        >
          <p className="text-meta" style={{ color: 'var(--text-light)' }}>
            © {new Date().getFullYear()} {hotelInfo.name}. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link
              to="/privacy"
              className="text-meta hover:underline"
              style={{ color: 'var(--text-light)', textDecoration: 'none' }}
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-meta hover:underline"
              style={{ color: 'var(--text-light)', textDecoration: 'none' }}
            >
              Terms of Service
            </Link>
          </div>
        </div>
        <div className="mt-6 text-center">
          <a
            href="https://absp.online"
            target="_blank"
            rel="noopener noreferrer"
            className="text-meta hover:underline"
            style={{ color: 'var(--text-light)', textDecoration: 'none' }}
          >
            Made by ABSP
          </a>
        </div>
      </div>
    </footer>
  );
};
